import { CasinoPartner } from '@/app/components/CasinoPartnerCard';

// Single source of truth for the partner/bonus offers shown on the homepage
// (components/Partners) and the /bonuses page.
export const casinoPartners: CasinoPartner[] = [
    // {
    //     name: 'CASINOBET.COM',
    //     code: 'SOKOLOCO',
    //     img: '/img/logos/casinobet.webp',
    //     url: 'https://casinobet.com/?a=4f4326',
    //     featured: 'Unlock Up to 65% Rakeback & Cashback',
    //     mainBonus: '400%',
    //     bonusDetail: 'UP TO 1 BTC',
    //     extraBonus: '400 FREE SPINS',
    //     highlights: [
    //         '65% Rakeback & Cashback',
    //         'Massive 400% welcome bonus',
    //         '400 Free Spins included',
    //         'Crypto-friendly platform'
    //     ]
    // },
    // {
    //     name: 'SHOCK.COM',
    //     code: 'SOKOLOCO',
    //     img: '/img/logos/shockcom.webp',
    //     url: 'https://shock.com/?r=Sokoloco',
    //     featured: '100% Match Bonus',
    //     mainBonus: '100%',
    //     bonusDetail: 'UP TO $1,500',
    //     extraBonus: 'INSTANT MATCH',
    //     bonusExample: '',
    //     highlights: [
    //         '100% deposit match bonus',
    //         'Maximum match: $1,500',
    //         'Instant bonus credit',
    //         'Lightning-fast withdrawals'
    //     ]
    // },
    // {
    //     name: 'ACEBET.COM',
    //     code: 'SOKOLOCO',
    //     img: '/img/logos/acebet.svg',
    //     url: 'https://acebet.com/welcome/r/sokoloco',
    //     featured: 'FREE 1$ WELCOME BONUS',
    //     mainBonus: '50%',
    //     bonusDetail: 'UP TO $1,000',
    //     extraBonus: 'INSTANT MATCH',
    //     bonusExample: '',
    //     highlights: [
    //         '50% deposit match bonus',
    //         'Rewards | Challenges | Races',
    //         'Instant bonus credit',
    //         'Lightning-fast withdrawals'
    //     ]
    // }
    {
        name: 'STAKE.COM',
        code: 'SOKOLOCO',
        img: '/img/logos/stakecom.svg',
        url: 'https://stake.com/?offer=sokoloco&c=c9bb838557',
        featured: '$3 Daily Reload for 7 Days',
        mainBonus: '$21',
        bonusDetail: '$3 PER DAY',
        extraBonus: '7-DAY RELOAD',
        bonusExample: 'Deposit & wager $21 → get $3 daily',
        highlights: [
            '$3 reload every day for 7 days',
            'Deposit & wager $21 or more',
            'Total reload value: $21',
            'Only for new accounts',
            'KYC level 2 required',
            'Under SOKOLOCO campaign',
            'Valid for 24 hours from registration'
        ]
    },
    {
        name: 'MOON.COM',
        code: 'SOKOLOCO',
        img: '/img/logos/mooncom.svg',
        url: 'https://moon.com/?c=c9bb838557&offer=sokoloco',
        featured: 'Weekly Bonus for the Community',
        mainBonus: '1000x',
        bonusDetail: 'MAX LEVERAGE',
        extraBonus: 'WEEKLY BONUS',
        bonusExample: 'Bet up or down on crypto, stocks & commodities',
        highlights: [
            'Weekly bonus for our community',
            'Trade crypto, stocks & commodities',
            'Bet on the price going up or down',
            'Leverage up to 1000x',
            'Giveaways & rewards coming soon'
        ]
    }
];
